import request from '@/services/axios'

//用户信息
export const getUserInfo = (data:any)=>{
    return request.post('/api/user/info', data)
}

//充值列表
export const chargeCatalog = (data:any)=>{
    return request.post('/api/charge/catalog', data)
}

//积分列表
export const accountTradeList = (data:any)=>{
    return request.post('/api/account/trade/list', data)
}

//权益列表
export const getVipequity = (data:any)=>{
    return request.post('/api/vip/equity', data)
}

//获取文件签名令牌
export const getFileSign = (data:any)=>{
    return request.post('/api/c/file/sign', data)
}

//用户反馈
export const feedbackSubmit = (data:any)=>{
    return request.post('/api/feedback/submit', data)
}

//收藏/取消收藏
export const toggleFavorite = (data:any)=>{
    return request.post('/api/favorites/toggle', data)
}


//恢复注销账号
export const logRecover = (data:any)=>{
    return request.post('/api/login/logout/recover', data)
}
//退出登录
export const logQuit = (data:any)=>{
    return request.post('/api/login/quit', data)
}
//用户注销
export const logOut = (data:any)=>{
    return request.post('/api/login/logout', data)
}
//创建支付订单
export const chargeOrder = (data:any)=>{
    return request.post('/api/charge/order', data)
}

//创建支付订单
export const checkCharge = (data:any)=>{
    return request.post('/api/charge/order/check', data)
}

//验证码登录
export const loginPhone = (data:any)=>{
    return request.post('/api/login/sms', data)
}

//密码登录
export const loginPassword = (data:any)=>{
    return request.post('/api/login/password', data)
}

//获取验证码（params 走 RSA 加密；可选传入 config 合并 headers 等）
export const getCode = (data:any, config?: any)=>{
    return request.post('/api/login/send/sms', data, { ...config, encrypt: true })
}

//注销账号发送验证码
export const getLogoutCode = (data:any)=>{
    return request.post('/api/login/logout/sms', data)
}

//微信扫码登录（可选 config.headers，如 X-PlTime）
export const loginWechat = (data:any = {}, config?: any)=>{
    return request.post('/api/login/wechat/qrcode', data, config)
}

//微信扫码登录
export const checkWechat = (data:any)=>{
    return request.post('/api/login/wechat/qrcode/check', data)
}

//获取活动信息
export const getActivityInfo = (data:any)=>{
    return request.post('/api/activity/info', data)
}

//按展示位置获取 Banner 列表
export const getBannerListByLocation = (data:any)=>{
    return request.post('/api/activity/banner/list-by-location', data)
}

//按展示位置获取弹窗列表
export const getModalListByLocation = (data:any)=>{
    return request.post('/api/activity/modal/list-by-location', data)
}

//隐藏弹窗
export const hiddenActivity = (data:any)=>{
    return request.post('/api/activity/modal/hidden', data)
}

//兑换码兑换
export const promocodeExchange = (data:any)=>{
    return request.post('/api/promocode/exchange', data)
}

//统一发送短信验证码接口
export const getSmsCode = (data:any)=>{
    return request.post('/api/user/sms/send', data)
}
//统一发送短信验证码接口(需要加密)
export const getSetPwdSmsCode = (data:any)=>{
    return request.post('/api/login/setPwd/sms', data)
}
//设置密码(需要加密)
export const setPassword = (data:any)=>{
    return request.post('/api/login/pwd/set', data, { encrypt: true })
}

//短信验证码校验接口
export const getSmsCheckCode = (data:any)=>{
    return request.post('/api/user/sms/check', data)
}

//绑定手机号码
export const bindNumber = (data:any)=>{
    return request.post('/api/user/bindNumber', data)
}

//购买记录的历史接口
export const chargeHistory = (data:any)=>{
    return request.post('/api/charge/history', data)
}

//获取用户相关
export const getTeen = (data:any)=>{
    return request.post('/api/c/user/get', data)
}

//开启青少年模式
export const openTeen = (data:any)=>{
    return request.post('/api/teen-mode/open', data)
}

//关闭青少年模式
export const closeTeen = (data:any)=>{
    return request.post('/api/teen-mode/close', data)
}

//获取RSA公钥
export const getRSAPublicKey = (data:any)=>{
    return request.post('/api/c/get', data)
}

//密码登录(需要加密)
export const loginByPassword = (data:any)=>{
    return request.post('/api/login/pwd', data, { encrypt: true })
}

//获取权益说明列表
export const getChargeBenefitIntro = (data:any)=>{
    return request.post('/api/charge/benefit/intro', data)
}

// 按用户ID查询简要信息
export const simpleInfo = (data:any)=>{
    return request.post('/api/vip/give-sub-account-equity', data)
}

// 获取会员挽留弹窗
export const getVipRetentionPopup = (data:any)=>{
    return request.post('/api/charge/vip-retention-popup', data)
}